export default "__VITE_ASSET__CsXVbckY__"